export const environment = {
  production: false,
  envName: "development",
  authScope: "api://4006d68b-dc72-40cb-8e5b-d7803e5c369a/access_scope",
  redirectUri: "https://devl-adudssportal.sandbox.dealeruplift.net",
  apiUrl: "https://devl-adudssportal.sandbox.dealeruplift.net/backend/",
  agGridLicense:
    "Using_this_{AG_Grid}_Enterprise_key_{AG-095144}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Armatus_Dealer_Uplift}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{.dealeruplift.net}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{.dealeruplift.net}_need_to_be_licensed___{.dealeruplift.net}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{22_August_2027}____[v3]_[01]_MTgxODg4OTIwMDAwMA==71f19cec83313e2551630e290346062d",
  SOLVE360: "http://graphql2.devl-adudssportal.sandbox.dealeruplift.net/graphiql",
  MAGEURL: "http://graphql1.tmp-devl-adudssportal.sandbox.dealeruplift.net/graphiql",
  clientId: "4006d68b-dc72-40cb-8e5b-d7803e5c369a",
  domainUrl: "https://devl-adudssportal.sandbox.dealeruplift.net",
  proxyUrl: "https://solve360.sandbox.dealeruplift.net",
  webSocketLink: "wss://devl-api.sandbox.dealeruplift.net/subscriptions",
  enableSync: true,
  biDirectionalNotificationFlag: false,
  defaultTestDataTag: true,
  awsAccessKey: "",
  awsSecretKey: "",
  awsRegion: "us-east-1",
  awsBucket: "devl-updates-from-portal",
  awsFolder: "uploaded_as_reports",
  PRMPORTAL: "https://devl-prmportal.sandbox.dealeruplift.net",
  DU_JOBS_URL: "https://uat-portal.production.dealeruplift.net/duJobsGraphqlCustom",
  AUDITOR_URL: "https://devl-auditportal.sandbox.dealeruplift.net/#/auditor-reports",
  AUDITOR_LIST_URL: "https://devl-auditportal.sandbox.dealeruplift.net/#/auditor-list",
  SUBMISSION_SUMMARY_URL: "https://devl-auditportal.sandbox.dealeruplift.net/#/submission-summary",
  AUDIT_ML_URL: "https://devl-auditmldashboard.sandbox.dealeruplift.net",
  AUDITOR_MAIN_URL: "https://devl-auditportal.sandbox.dealeruplift.net",
  SCHEDULER_PORTAL_URL: "https://devl-scheduler.sandbox.dealeruplift.net",
  MAPPER_PORTAL_URL: "https://mapper.sandbox.dealeruplift.net",
  DATA_SUPPORT_URL: "https://devl-datasupport.sandbox.dealeruplift.net",
  ENTITYDB_PORTAL_URL: "https://entitydb.sandbox.dealeruplift.net",
  salesAppStageUpdateURI:
    "https://entitydb.sandbox.dealeruplift.net/graphql/solve360/v1/company/stage-update",
  auditNotesUIFlag: false,
  projectFacilitationURL: "https://project-facilitation.sandbox.dealeruplift.net",
  PFPORTAL: "https://project-facilitation.sandbox.dealeruplift.net",
  domainUrlLocal: "https://devl-sharepoint.sandbox.dealeruplift.net",
  MAILGUN_DOMAIN: "sandbox.dealeruplift.net",
  MAILGUN_API_KEY: "c1c0270904980d220df01db5c55f8bff",
  ENTITY_SOLVE_USER: "271903646",
  ADMIN_GROUP_ID: "1edc3403-7d5c-44b8-9f5d-de143010677b",
  HOUSE_ACCOUNT_SP: "Rijo Joseph",
};
